import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
});

const AxiosInterceptor = ({ children }) => {
  // Request interceptor
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("@TOKEN");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor
  axiosInstance.interceptors.response.use(
    (response) => {
      const { data } = response ?? {};
      return data;
    },
    ({ response }) => {
      const { data } = response ?? {};
      alert(data?.message ?? "ServerError");
      throw data?.message ?? "ServerError";
    }
  );

  return { children };
};

export default AxiosInterceptor;
